module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAAhUlEQVRoge3WMQqAMBAF0UQ8y97/OpvLxEawCUi6nTCvsXGRweb3zJxtT3+fpe+uzY9gGEZjGI1hNIbRGEZzt2+L7SpxFxHLl4/+Y6VX+t/dGGN5dOwfM4zGMBrDaAyjMYzGdU/juqcxjMYwGsNoDKMxjMZ1T+O6pzGMxjAaw2gMozGM5gH7VxwLS8ARDwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/allEqualSixteenths.png
// module id = ImMJ
// module chunks = 0